// @flow
import { MantenimientosActionTypes } from './constants';

// import { APICore } from '../../helpers/api/apiCore';

// const api = new APICore();

const INIT_STATE = {
    mantenimiento: {},
    listaMantenimientos: [],
    loading: false,
    error: false,
    formSubmited: false
};

type MantenimientosAction = {
    type: string,
    payload: { actionType?: string, data?: any, error?: string },
};
type State = { mantenimiento?: {} | null, listaMantenimientos?: [] | null, loading?: boolean, +value ?: boolean };

const Mantenimientos = (state: State = INIT_STATE, action: MantenimientosAction): any => {
    // console.log(action);
    switch (action.type) {
        case MantenimientosActionTypes.API_RESPONSE_SUCCESS:
            switch (action.payload.actionType) {
                case MantenimientosActionTypes.GET_MANTENIMIENTO: {
                    return {
                        ...state,
                        mantenimiento: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                case MantenimientosActionTypes.CREATE_MANTENIMIENTO: {
                    return {
                        ...state,
                        // mantenimiento: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case MantenimientosActionTypes.UPDATE_MANTENIMIENTO: {
                    return {
                        ...state,
                        // mantenimiento: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case MantenimientosActionTypes.DELETE_MANTENIMIENTO: {
                    return {
                        ...state,
                        // mantenimiento: action.payload.data,
                        error: false,
                        loading: false,
                        formSubmited: true
                    };
                }
                case MantenimientosActionTypes.LIST_MANTENIMIENTOS: {
                    return {
                        ...state,
                        listaMantenimientos: action.payload.data,
                        error: false,
                        loading: false,
                    };
                }
                // case MantenimientosActionTypes.LIST_INVOICES_BY_CLIENT: {
                //     return {
                //         ...state,
                //         listaFacturas: action.payload.data,
                //         error:false,
                //         loading: false,
                //     };
                // }
                default:
                    return { ...state };
            }

        case MantenimientosActionTypes.API_RESPONSE_ERROR:
            switch (action.payload.actionType) {
                case MantenimientosActionTypes.GET_MANTENIMIENTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        mantenimiento: {},
                        loading: false,
                    };
                }
                case MantenimientosActionTypes.CREATE_MANTENIMIENTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        // mantenimiento:{},
                        loading: false,
                        formSubmited: true
                    };
                }
                case MantenimientosActionTypes.UPDATE_MANTENIMIENTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        // mantenimiento:{},
                        loading: false,
                        formSubmited: true
                    };
                }
                case MantenimientosActionTypes.DELETE_MANTENIMIENTO: {
                    return {
                        ...state,
                        error: action.payload.error,
                        // mantenimiento:{},
                        loading: false,
                        formSubmited: true
                    };
                }

                case MantenimientosActionTypes.LIST_MANTENIMIENTOS: {
                    return {
                        ...state,
                        error: action.payload.error,
                        listaMantenimientos: [],
                        loading: false,
                    };
                }
                // case MantenimientosActionTypes.LIST_INVOICES_BY_CLIENT: {
                //     return {
                //         ...state,
                //         error: action.payload.error,
                //         listaFacturas: [],
                //         loading: false,
                //     };
                // }
                default:
                    return { ...state };
            }

        case MantenimientosActionTypes.GET_MANTENIMIENTO:
            return { ...state, error: false, loading: true, formSubmited: false };
        case MantenimientosActionTypes.CREATE_MANTENIMIENTO:
            return { ...state, error: false, loading: true };
        case MantenimientosActionTypes.UPDATE_MANTENIMIENTO:
            return { ...state, error: false, loading: true };
        case MantenimientosActionTypes.DELETE_MANTENIMIENTO:
            return { ...state, error: false, loading: true, formSubmited: false };
        case MantenimientosActionTypes.LIST_MANTENIMIENTOS:
            return { ...state, error: false, loading: true, formSubmited: false };
        // case MantenimientosActionTypes.LIST_INVOICES_BY_CLIENT:
        //     return { ...state,error:false, loading: true };
        case MantenimientosActionTypes.RESET:
            return {
                ...state,
                loading: false,
                error: false,
                mantenimiento: {},
                listaMantenimientos: [],
                formSubmited: false
            };
        default:
            return { ...state };
    }
};

export default Mantenimientos;
